import { ApiResponseData, skipioAxios } from ".";

type Billing = {
  billingMethod: "stripe";
  canSelfCancel: boolean;
  canUncancel: boolean;
  customer: {
    card: {
      last4: string;
      brand: string;
      expMonth: number;
      expYear: number;
    };
  };
  subscription?: {
    billingCycleAnchor: string;
    cancelAt: string;
    endedAt: string;
    currentPeriodEnd: string;
    currentPeriodStart: string;
    startDate: string;
    trialEnd: string;
    trialStart: string;
    cancelAtPeriodEnd: boolean;
    status: string;
    items: {
      amount: number;
      interval: string;
      type: string;
      productDescription: string;
      productName: string;
    }[];
  };
  upcomingInvoice: {
    amountDue: number;
    attemptCount: number;
    created: string;
    attempted: boolean;
    nextPaymentAttempt: string;
    subtotal: number;
    totalDiscountAmounts: {
      amount: number;
      discount: string;
    }[];
    total: number;
    items: {
      amount: number;
      description: string;
      quantity: number;
      productName: string;
      productDescription: string;
    }[];
  };
  paidInvoices: {
    amountDue: number;
    attemptCount: number;
    created: string;
    attempted: boolean;
    subtotal: number;
    total: number;
    hostedInvoiceUrl: string;
    invoicePdf: string;
    items: {
      amount: number;
      description: string;
      quantity: number;
      productName: string;
      productDescription: string;
    }[];
  };
};

export const fetchBilling = async () => {
  const res = await skipioAxios({
    method: "GET",
    url: "billing",
  });

  return res.data as ApiResponseData<Billing>;
};
